module.exports = __webpack_public_path__ + "static/media/man_barrels_getty_mobile.d2745667.jpg";